import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Accordion, CheckboxFilledIcon, CheckboxIcon, Layout } from '@utilities';

import { getDisplayCurrency } from '../../utilities/helpers';

import styles from './_index.module.scss';

const Addons = ({ addons, onAddonChange, paymentOption }) => {
  const handleToggle = (id, selected) => {
    onAddonChange(id, { selected });
  };

  return (
    <Accordion className={styles['addons']} isDefaultOpen label="Optional Add-ons">
      <Layout.Flex.Column as="ul" className={styles['addon-list']} gap="small">
        {addons.map(({ description, id, prices, selected = false, title }) => {
          const value = prices?.[paymentOption.currency] ?? 0;

          return (
            <Layout.Flex
              aria-checked={selected}
              as="li"
              className={classNames(styles['addon-item'], { [styles['is-selected']]: selected })}
              gap="small"
              key={id}
              onClick={() => handleToggle(id, !selected)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleToggle(id, !selected);
                }
              }}
              role="checkbox"
              tabIndex="0"
            >
              <div className={styles['addon-checkbox']}>
                {selected ? <CheckboxFilledIcon /> : <CheckboxIcon />}
              </div>
              <Layout.Fill>
                <Layout.Flex.Column className={styles['addon-detail']} gap="small">
                  <Layout.Flex>
                    <Layout.Fill>
                      <strong className={styles['addon-name']}>{title}</strong>
                    </Layout.Fill>
                    <span>
                      {value} {getDisplayCurrency({ paymentOption, value })}
                    </span>
                  </Layout.Flex>
                  {description && <div>{description}</div>}
                </Layout.Flex.Column>
              </Layout.Fill>
            </Layout.Flex>
          );
        })}
      </Layout.Flex.Column>
    </Accordion>
  );
};

Addons.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.object).isRequired, // see Cart component for shape
  onAddonChange: PropTypes.func.isRequired,
  paymentOption: PropTypes.object.isRequired,
};

export default Addons;
